"use strict";
import { ServicesCommon } from "../src/servicesCommon";
import { Modal } from "bootstrap";

const ServicesShow = {
  showToolHint: () => {
    // スマホ：「お届け目安」のツールチップ表示（※PCはcssのみで制御）
    if (document.querySelector(".toolhint")) {
      document.querySelector(".toolhint").addEventListener("click", (e) => {
        e.currentTarget.querySelector(".tip").classList.toggle("is_show");
      });
      // ボタン以外をクリックした場合も閉じる
      document.addEventListener("touchend", (e) => {
        if (e.target.closest(".toolhint") === null) {
          document.querySelector(".toolhint .tip").classList.remove("is_show");
        }
      });
    }
  },
  // 違反報告後、成功した場合は完了モーダルを立ち上げる
  showReportCompleteModal: () => {
    const queryStrings = window.location.search.slice(1);
    const queries = {};

    if (!queryStrings) {
      return queries;
    }

    queryStrings.split("&").forEach(function (queryStrings) {
      var queryArray = queryStrings.split("=");
      queries[queryArray[0]] = queryArray[1];
    });

    if (queries["send_report"] == "success") {
      document.getElementById("reportModal").classList.add("afterSend");
      const modal = new Modal(document.getElementById("reportModal"));
      modal.show();
    }
  },

  showImageModal: () => {
    const images = document.querySelectorAll(".js_image_modal");

    images.forEach((image) => {
      image.addEventListener("click", () => {
        const modal = new Modal(document.getElementById("serviceImgModal"));
        modal.show();
      });
    });
  },
};

// ページロード後にグローバル定数にServicesFormを追加する
document.addEventListener("DOMContentLoaded", () => {
  Object.defineProperty(globalThis, "ServicesShow", {
    value: ServicesShow,
    writable: false,
  });
  ServicesCommon.onTouchServiceImageModal();
  ServicesShow.showToolHint();
  ServicesShow.showReportCompleteModal();
  ServicesShow.showImageModal();
});
